import React from 'react';
import { View } from 'react-native';
import { IntersectionObserverView } from './intersectionObserver/index';
import PropTypes from 'prop-types';

const TraceIoView = (props) => {
  const { traceId, children, traceData, scmv2, pageName, statSend, scope, ...args } = props;

  const extraData = {
    traceId,
    // ConfigData,
    traceData,
    scmv2,
    pageName,
    statSend,
    ...args,
  };
  return <IntersectionObserverView children={children} scope={scope} extraData={extraData} />;
};

TraceIoView.prototype = {
  traceId: PropTypes.string, // 根据traceid找到响应的配置config
  children: PropTypes.node, // 该组件中包的dom, 将原封不动展示
  traceData: PropTypes.object, // 需要上报的数据，改参数将被传递给config中的func
  scmv2: PropTypes.string,
  pageName: PropTypes.string, // b位
  statSend: PropTypes.object, // 发送打点 具体看StatSend
  scope: PropTypes.string, // 曝光的唯一key值
};

TraceIoView.defaultProps = {
  traceId: '',
  traceData: {},
  statSend: { getParam: () => ({ spm: '' }), visible: () => {}, touch: () => {}, view: () => {} },
};

export default TraceIoView;
